import { Injectable } from '@angular/core';

import { CustomField } from 'src/models';

import { GenericObjectsService } from './generic-objects.service';

interface GetConversationsWithFieldParams {
  limit?: number;
  cursor?: string;
  order?: string[];
  descending?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class CustomFieldsService extends GenericObjectsService<CustomField> {
  protected baseUrl = '/custom-fields';

  getConversationsWithField(customFieldId: string, params?: GetConversationsWithFieldParams) {
    return this.apiService.postPromise(`${this.baseUrl}/${customFieldId}/conversations`, params || {});
  }
}
